// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-section {
  margin: 1rem 0;
}

/* Desktop: side-by-side cards */
.payment-dual-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

/* Mobile: hide dual cards, show toggle + single card */
.payment-toggle-wrapper,
.payment-mobile-cards {
  display: none;
}

.payment-toggle-hint {
  margin: 0 0 0.5rem;
  font-size: 0.8rem;
  color: var(--text-secondary);
  font-weight: 500;
}

.payment-version-select-header {
  margin-bottom: 0.75rem;
  text-align: center;
}

.payment-toggle-title {
  margin: 0 0 0.35rem;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-primary);
}

.payment-version-select-hint {
  margin: 0;
  font-size: 0.82rem;
  color: var(--text-secondary);
  line-height: 1.4;
}

/* Segmented toggle for VX/Elite (mobile only) */
.payment-toggle {
  display: flex;
  gap: 0.35rem;
  padding: 0.35rem;
  background: var(--bg-secondary);
  border-radius: 12px;
  border: 1px solid var(--border-primary);
  margin-bottom: 1rem;
}

.payment-toggle-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border: 2px solid var(--border-primary);
  border-radius: 10px;
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  font-weight: 600;
  font-size: 0.88rem;
  cursor: pointer;
  transition: all 0.25s ease;
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;
}

.toggle-btn-icon {
  font-size: 1.2rem;
  line-height: 1;
  flex-shrink: 0;
}

.toggle-btn-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.15rem;
}

.toggle-btn-label {
  font-size: 0.9rem;
  font-weight: 700;
}

.payment-toggle-btn:hover:not(.active) {
  background: var(--bg-primary);
  color: var(--text-primary);
  border-color: var(--border-secondary);
}

.payment-toggle-btn:focus-visible {
  outline: 2px solid var(--accent-primary);
  outline-offset: 2px;
}

.payment-toggle-btn.active.toggle-btn-vx {
  background: rgba(59, 130, 246, 0.12);
  color: var(--accent-primary);
  border-color: var(--accent-primary);
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);
}

.payment-toggle-btn.active.toggle-btn-elite {
  background: rgba(212, 160, 23, 0.12);
  color: #b8860b;
  border-color: #b8860b;
  box-shadow: 0 2px 8px rgba(212, 160, 23, 0.2);
}

.toggle-badge {
  display: inline-block;
  padding: 0.15rem 0.5rem;
  border-radius: 12px;
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.payment-toggle-btn.active.toggle-btn-vx .toggle-badge {
  background: rgba(59, 130, 246, 0.2);
  color: var(--accent-primary);
}

.payment-toggle-btn.active.toggle-btn-elite .toggle-badge {
  background: rgba(212, 160, 23, 0.2);
  color: #b8860b;
}

.payment-toggle-btn:not(.active) .toggle-badge.badge-vx {
  background: rgba(59, 130, 246, 0.2);
  color: var(--accent-primary);
}

.payment-toggle-btn:not(.active) .toggle-badge.badge-elite {
  background: rgba(212, 160, 23, 0.2);
  color: #d4a017;
}

/* Single card layout */
.payment-single-card {
  max-width: 600px;
  margin: 0 auto;
}

/* Base card styles */
.payment-card,
.payment-single-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 14px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: relative;
}

/* Elite card accent */
.payment-card-elite {
  border-top: 3px solid #d4a017;
}

/* VX card accent */
.payment-card-vx {
  border-top: 3px solid var(--accent-primary);
}

.payment-card-standalone {
  border-top: 3px solid var(--accent-primary);
}

/* Badge */
.card-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  align-self: flex-start;
}

.badge-elite {
  background: linear-gradient(135deg, #d4a017, #b8860b);
  color: #fff;
}

.badge-vx {
  background: var(--accent-primary);
  color: #fff;
}

/* Card content */
.card-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.card-description {
  color: var(--text-secondary);
  font-size: 0.9rem;
  line-height: 1.6;
  margin: 0;
}

.card-note {
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-size: 0.85rem;
  line-height: 1.5;
}

.card-note-warning {
  background: rgba(245, 158, 11, 0.1);
  border-left: 3px solid var(--warning);
  color: var(--text-secondary);
}

.card-note-info {
  background: rgba(59, 130, 246, 0.08);
  border-left: 3px solid var(--accent-primary);
  color: var(--text-secondary);
}

/* Action buttons */
.card-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.7rem 1.4rem;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  text-align: center;
}

.btn-elite {
  background: linear-gradient(135deg, #d4a017, #b8860b);
  color: white;
}

.btn-elite:hover {
  filter: brightness(1.1);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(212, 160, 23, 0.4);
}

.btn-vx-store {
  background: var(--bg-tertiary);
  color: var(--text-primary);
  border: 1px solid var(--border-primary);
}

.btn-vx-store:hover {
  background: var(--accent-primary);
  color: white;
  border-color: var(--accent-primary);
  transform: translateY(-2px);
}

.btn-vx-download {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: white;
  border: none;
  font-size: 0.95rem;
  padding: 0.8rem 1.6rem;
  box-shadow: 0 3px 12px rgba(37, 99, 235, 0.35);
  gap: 0.5rem;
}

.btn-vx-download:hover {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  transform: translateY(-2px);
  box-shadow: 0 5px 20px rgba(37, 99, 235, 0.5);
}

.btn-download-icon {
  font-size: 1.1rem;
}

/* VX/Elite comparison intro (above toggle / dual cards) */
.payment-version-intro {
  margin-bottom: 1.25rem;
  text-align: center;
}

.payment-version-intro .payment-toggle-title {
  margin-bottom: 0.4rem;
}

.payment-version-intro .payment-version-select-hint {
  max-width: 40rem;
  margin: 0 auto 0.9rem;
}

.payment-version-compare {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
  text-align: left;
  margin-bottom: 0.85rem;
}

.payment-version-compare-col {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  padding: 0.85rem 1rem;
}

.payment-version-compare-col.compare-vx {
  border-color: rgba(59, 130, 246, 0.45);
}

.payment-version-compare-col.compare-elite {
  border-color: rgba(212, 160, 23, 0.5);
}

.compare-head {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.55rem;
}

.compare-head strong {
  color: var(--text-primary);
  font-size: 0.95rem;
}

.payment-version-compare-col ul {
  margin: 0;
  padding-left: 1.1rem;
  color: var(--text-secondary);
  font-size: 0.82rem;
  line-height: 1.45;
}

.payment-version-compare-col li {
  margin-bottom: 0.3rem;
}

.payment-version-compare-col li:last-child {
  margin-bottom: 0;
}

.payment-vx-warning {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.7rem 1rem;
  border-radius: 8px;
  font-size: 0.82rem;
  font-weight: 600;
  line-height: 1.45;
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.4);
  color: var(--text-primary);
  text-align: left;
}

.vx-warning-icon {
  font-size: 1rem;
  flex-shrink: 0;
  line-height: 1.3;
}

/* Beta notice */
.payment-beta-notice {
  text-align: center;
  padding: 3rem 2rem;
  background: var(--bg-secondary);
  border-radius: 14px;
  border: 1px dashed var(--border-secondary);
}

.beta-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  opacity: 0.6;
}

.payment-beta-notice h3 {
  font-size: 1.3rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 0.75rem;
}

.payment-beta-notice p {
  color: var(--text-secondary);
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0;
  max-width: 500px;
  margin: 0 auto;
}

/* Paddle Checkout (reused in multiple cards) */
.paddle-checkout {
  margin-top: 0.5rem;
}

.price-display {
  margin: 0.75rem 0;
  text-align: center;
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.price-amount {
  font-size: 2rem;
  font-weight: 700;
  color: var(--accent-primary);
  margin: 0;
}

.price-tax {
  font-size: 0.9rem;
  color: var(--text-secondary);
  margin: 0;
}

.wfid-input-section {
  margin: 1rem 0;
}

.wfid-description {
  margin-bottom: 0.75rem;
  color: var(--text-secondary);
  font-size: 0.85rem;
}

.input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.wfid-input {
  width: 100%;
  padding: 0.7rem 1rem;
  font-size: 1rem;
  background: var(--bg-primary);
  color: var(--text-primary);
  border: 2px solid var(--border-primary);
  border-radius: 8px;
  transition: all 0.3s ease;
}

.wfid-input:focus {
  outline: none;
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.1);
}

.wfid-input.valid {
  border-color: var(--success);
  background-color: rgba(52, 211, 153, 0.08);
}

.wfid-input.invalid {
  border-color: var(--error);
}

.valid-indicator {
  position: absolute;
  right: 1rem;
  color: var(--success);
  font-size: 1.2rem;
  font-weight: bold;
}

.validation-error,
.validation-warning,
.purchase-error {
  margin-top: 0.5rem;
  padding: 0.5rem;
  border-radius: 6px;
  font-size: 0.85rem;
}

.validation-error {
  color: var(--warning);
  background: rgba(251, 191, 36, 0.1);
  border: 1px solid rgba(251, 191, 36, 0.3);
}

.validation-warning {
  color: var(--warning);
  background: rgba(251, 191, 36, 0.1);
  border: 1px solid rgba(251, 191, 36, 0.3);
}

.purchase-error {
  color: var(--error);
  background: rgba(248, 113, 113, 0.1);
  border: 1px solid rgba(248, 113, 113, 0.3);
}

.wfid-guide-link,
.wfid-guide-link-inline {
  color: var(--accent-primary);
  text-decoration: underline;
  font-weight: 500;
}

.wfid-guide-link:hover,
.wfid-guide-link-inline:hover {
  color: var(--accent-hover);
}

.wfid-input.warn {
  border-color: var(--warning);
  background-color: rgba(251, 191, 36, 0.06);
}

.purchase-btn-warn {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 50%, #b45309 100%) !important;
  box-shadow: 0 4px 16px rgba(245, 158, 11, 0.4) !important;
}

.purchase-section {
  text-align: center;
  margin: 1rem 0;
}

.purchase-btn {
  padding: 0.85rem 2rem;
  font-size: 1.1rem;
  width: 100%;
  background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 50%, #2563eb 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(37, 99, 235, 0.4);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.purchase-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 50%, #1d4ed8 100%);
  box-shadow: 0 6px 24px rgba(37, 99, 235, 0.6);
}

.purchase-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  box-shadow: none;
}

.payment-methods {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin: 1rem 0;
  padding: 0.6rem;
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: 10px;
}

.payment-methods img {
  height: 40px;
  width: auto;
  object-fit: contain;
  padding: 0.25rem 0.4rem;
  border-radius: 6px;
  opacity: 0.85;
  transition: opacity 0.2s ease, filter 0.2s ease;
  background: rgba(255, 255, 255, 0.9);
}

.payment-methods img:hover {
  opacity: 1;
}

.payment-info {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--border-primary);
}

.payment-info p {
  margin: 0 0 0.3rem;
  color: var(--text-secondary);
  font-size: 0.8rem;
  line-height: 1.5;
}

.payment-guide-link,
.payment-guide-link-inline {
  color: var(--accent-primary);
  text-decoration: underline;
  font-weight: 500;
}

.payment-guide-link:hover,
.payment-guide-link-inline:hover {
  color: var(--accent-hover);
}

.payment-email-note {
  margin-top: 0.5rem;
}

.payment-email-list {
  margin: 0.25rem 0 0;
  padding-left: 1.1rem;
  list-style: disc;
  color: var(--text-secondary);
  font-size: 0.8rem;
  line-height: 1.5;
}

.payment-email-list li {
  margin-bottom: 0.15rem;
}

/* Mobile */
@media (max-width: 680px) {
  .payment-dual-cards {
    display: none;
  }

  .payment-toggle-wrapper,
  .payment-mobile-cards {
    display: block;
  }

  .payment-card,
  .payment-single-card {
    padding: 1.25rem;
  }

  .card-title {
    font-size: 1.15rem;
  }

  .price-amount {
    font-size: 1.6rem;
  }

  .purchase-btn {
    padding: 0.75rem 1.5rem;
    font-size: 1rem;
  }

  .payment-methods img {
    height: 32px;
  }

  .payment-toggle-btn {
    padding: 0.65rem 0.6rem;
    font-size: 0.8rem;
    gap: 0.4rem;
    min-height: 54px;
  }

  .payment-toggle-btn:not(.active) {
    border-color: var(--border-secondary);
    border-style: dashed;
  }

  .toggle-badge {
    font-size: 0.6rem;
    padding: 0.1rem 0.4rem;
  }

  .toggle-btn-label {
    font-size: 0.82rem;
  }

  .payment-version-compare {
    grid-template-columns: 1fr;
  }

  .payment-toggle-wrapper {
    margin-bottom: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PaymentSection/PaymentSection.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA,uDAAuD;AACvD;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,uCAAuC;EACvC,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;;EAEE,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,6BAA6B;AAC/B;;AAEA,mBAAmB;AACnB;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;EAC5C,4BAA4B;AAC9B;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,8CAA8C;EAC9C,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;AACnB;;AAEA,0DAA0D;AAC1D;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,yCAAyC;EACzC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,6BAA6B;EAC7B,0BAA0B;EAC1B,uCAAuC;EACvC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;;EAGE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;;EAEE,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,qFAAqF;EACrF,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,0EAA0E;EAC1E,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;EAC7C,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,0EAA0E;EAC1E,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,+CAA+C;EAC/C,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,cAAc;EAChB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".payment-section {\n  margin: 1rem 0;\n}\n\n/* Desktop: side-by-side cards */\n.payment-dual-cards {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n}\n\n/* Mobile: hide dual cards, show toggle + single card */\n.payment-toggle-wrapper,\n.payment-mobile-cards {\n  display: none;\n}\n\n.payment-toggle-hint {\n  margin: 0 0 0.5rem;\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n.payment-version-select-header {\n  margin-bottom: 0.75rem;\n  text-align: center;\n}\n\n.payment-toggle-title {\n  margin: 0 0 0.35rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.payment-version-select-hint {\n  margin: 0;\n  font-size: 0.82rem;\n  color: var(--text-secondary);\n  line-height: 1.4;\n}\n\n/* Segmented toggle for VX/Elite (mobile only) */\n.payment-toggle {\n  display: flex;\n  gap: 0.35rem;\n  padding: 0.35rem;\n  background: var(--bg-secondary);\n  border-radius: 12px;\n  border: 1px solid var(--border-primary);\n  margin-bottom: 1rem;\n}\n\n.payment-toggle-btn {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  border: 2px solid var(--border-primary);\n  border-radius: 10px;\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n  font-weight: 600;\n  font-size: 0.88rem;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  white-space: nowrap;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.toggle-btn-icon {\n  font-size: 1.2rem;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.toggle-btn-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.15rem;\n}\n\n.toggle-btn-label {\n  font-size: 0.9rem;\n  font-weight: 700;\n}\n\n.payment-toggle-btn:hover:not(.active) {\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  border-color: var(--border-secondary);\n}\n\n.payment-toggle-btn:focus-visible {\n  outline: 2px solid var(--accent-primary);\n  outline-offset: 2px;\n}\n\n.payment-toggle-btn.active.toggle-btn-vx {\n  background: rgba(59, 130, 246, 0.12);\n  color: var(--accent-primary);\n  border-color: var(--accent-primary);\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);\n}\n\n.payment-toggle-btn.active.toggle-btn-elite {\n  background: rgba(212, 160, 23, 0.12);\n  color: #b8860b;\n  border-color: #b8860b;\n  box-shadow: 0 2px 8px rgba(212, 160, 23, 0.2);\n}\n\n.toggle-badge {\n  display: inline-block;\n  padding: 0.15rem 0.5rem;\n  border-radius: 12px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.payment-toggle-btn.active.toggle-btn-vx .toggle-badge {\n  background: rgba(59, 130, 246, 0.2);\n  color: var(--accent-primary);\n}\n\n.payment-toggle-btn.active.toggle-btn-elite .toggle-badge {\n  background: rgba(212, 160, 23, 0.2);\n  color: #b8860b;\n}\n\n.payment-toggle-btn:not(.active) .toggle-badge.badge-vx {\n  background: rgba(59, 130, 246, 0.2);\n  color: var(--accent-primary);\n}\n\n.payment-toggle-btn:not(.active) .toggle-badge.badge-elite {\n  background: rgba(212, 160, 23, 0.2);\n  color: #d4a017;\n}\n\n/* Single card layout */\n.payment-single-card {\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n/* Base card styles */\n.payment-card,\n.payment-single-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: 14px;\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  position: relative;\n}\n\n/* Elite card accent */\n.payment-card-elite {\n  border-top: 3px solid #d4a017;\n}\n\n/* VX card accent */\n.payment-card-vx {\n  border-top: 3px solid var(--accent-primary);\n}\n\n.payment-card-standalone {\n  border-top: 3px solid var(--accent-primary);\n}\n\n/* Badge */\n.card-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  align-self: flex-start;\n}\n\n.badge-elite {\n  background: linear-gradient(135deg, #d4a017, #b8860b);\n  color: #fff;\n}\n\n.badge-vx {\n  background: var(--accent-primary);\n  color: #fff;\n}\n\n/* Card content */\n.card-title {\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.card-description {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.card-note {\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  font-size: 0.85rem;\n  line-height: 1.5;\n}\n\n.card-note-warning {\n  background: rgba(245, 158, 11, 0.1);\n  border-left: 3px solid var(--warning);\n  color: var(--text-secondary);\n}\n\n.card-note-info {\n  background: rgba(59, 130, 246, 0.08);\n  border-left: 3px solid var(--accent-primary);\n  color: var(--text-secondary);\n}\n\n/* Action buttons */\n.card-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.7rem 1.4rem;\n  border-radius: 10px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  text-align: center;\n}\n\n.btn-elite {\n  background: linear-gradient(135deg, #d4a017, #b8860b);\n  color: white;\n}\n\n.btn-elite:hover {\n  filter: brightness(1.1);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(212, 160, 23, 0.4);\n}\n\n.btn-vx-store {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-primary);\n}\n\n.btn-vx-store:hover {\n  background: var(--accent-primary);\n  color: white;\n  border-color: var(--accent-primary);\n  transform: translateY(-2px);\n}\n\n.btn-vx-download {\n  background: linear-gradient(135deg, #3b82f6, #2563eb);\n  color: white;\n  border: none;\n  font-size: 0.95rem;\n  padding: 0.8rem 1.6rem;\n  box-shadow: 0 3px 12px rgba(37, 99, 235, 0.35);\n  gap: 0.5rem;\n}\n\n.btn-vx-download:hover {\n  background: linear-gradient(135deg, #2563eb, #1d4ed8);\n  transform: translateY(-2px);\n  box-shadow: 0 5px 20px rgba(37, 99, 235, 0.5);\n}\n\n.btn-download-icon {\n  font-size: 1.1rem;\n}\n\n/* VX/Elite comparison intro (above toggle / dual cards) */\n.payment-version-intro {\n  margin-bottom: 1.25rem;\n  text-align: center;\n}\n\n.payment-version-intro .payment-toggle-title {\n  margin-bottom: 0.4rem;\n}\n\n.payment-version-intro .payment-version-select-hint {\n  max-width: 40rem;\n  margin: 0 auto 0.9rem;\n}\n\n.payment-version-compare {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.75rem;\n  text-align: left;\n  margin-bottom: 0.85rem;\n}\n\n.payment-version-compare-col {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: 12px;\n  padding: 0.85rem 1rem;\n}\n\n.payment-version-compare-col.compare-vx {\n  border-color: rgba(59, 130, 246, 0.45);\n}\n\n.payment-version-compare-col.compare-elite {\n  border-color: rgba(212, 160, 23, 0.5);\n}\n\n.compare-head {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.55rem;\n}\n\n.compare-head strong {\n  color: var(--text-primary);\n  font-size: 0.95rem;\n}\n\n.payment-version-compare-col ul {\n  margin: 0;\n  padding-left: 1.1rem;\n  color: var(--text-secondary);\n  font-size: 0.82rem;\n  line-height: 1.45;\n}\n\n.payment-version-compare-col li {\n  margin-bottom: 0.3rem;\n}\n\n.payment-version-compare-col li:last-child {\n  margin-bottom: 0;\n}\n\n.payment-vx-warning {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  padding: 0.7rem 1rem;\n  border-radius: 8px;\n  font-size: 0.82rem;\n  font-weight: 600;\n  line-height: 1.45;\n  background: rgba(245, 158, 11, 0.1);\n  border: 1px solid rgba(245, 158, 11, 0.4);\n  color: var(--text-primary);\n  text-align: left;\n}\n\n.vx-warning-icon {\n  font-size: 1rem;\n  flex-shrink: 0;\n  line-height: 1.3;\n}\n\n/* Beta notice */\n.payment-beta-notice {\n  text-align: center;\n  padding: 3rem 2rem;\n  background: var(--bg-secondary);\n  border-radius: 14px;\n  border: 1px dashed var(--border-secondary);\n}\n\n.beta-icon {\n  font-size: 2.5rem;\n  margin-bottom: 1rem;\n  opacity: 0.6;\n}\n\n.payment-beta-notice h3 {\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 0.75rem;\n}\n\n.payment-beta-notice p {\n  color: var(--text-secondary);\n  font-size: 0.95rem;\n  line-height: 1.6;\n  margin: 0;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n/* Paddle Checkout (reused in multiple cards) */\n.paddle-checkout {\n  margin-top: 0.5rem;\n}\n\n.price-display {\n  margin: 0.75rem 0;\n  text-align: center;\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.price-amount {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--accent-primary);\n  margin: 0;\n}\n\n.price-tax {\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n.wfid-input-section {\n  margin: 1rem 0;\n}\n\n.wfid-description {\n  margin-bottom: 0.75rem;\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n}\n\n.input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.wfid-input {\n  width: 100%;\n  padding: 0.7rem 1rem;\n  font-size: 1rem;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  border: 2px solid var(--border-primary);\n  border-radius: 8px;\n  transition: all 0.3s ease;\n}\n\n.wfid-input:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.1);\n}\n\n.wfid-input.valid {\n  border-color: var(--success);\n  background-color: rgba(52, 211, 153, 0.08);\n}\n\n.wfid-input.invalid {\n  border-color: var(--error);\n}\n\n.valid-indicator {\n  position: absolute;\n  right: 1rem;\n  color: var(--success);\n  font-size: 1.2rem;\n  font-weight: bold;\n}\n\n.validation-error,\n.validation-warning,\n.purchase-error {\n  margin-top: 0.5rem;\n  padding: 0.5rem;\n  border-radius: 6px;\n  font-size: 0.85rem;\n}\n\n.validation-error {\n  color: var(--warning);\n  background: rgba(251, 191, 36, 0.1);\n  border: 1px solid rgba(251, 191, 36, 0.3);\n}\n\n.validation-warning {\n  color: var(--warning);\n  background: rgba(251, 191, 36, 0.1);\n  border: 1px solid rgba(251, 191, 36, 0.3);\n}\n\n.purchase-error {\n  color: var(--error);\n  background: rgba(248, 113, 113, 0.1);\n  border: 1px solid rgba(248, 113, 113, 0.3);\n}\n\n.wfid-guide-link,\n.wfid-guide-link-inline {\n  color: var(--accent-primary);\n  text-decoration: underline;\n  font-weight: 500;\n}\n\n.wfid-guide-link:hover,\n.wfid-guide-link-inline:hover {\n  color: var(--accent-hover);\n}\n\n.wfid-input.warn {\n  border-color: var(--warning);\n  background-color: rgba(251, 191, 36, 0.06);\n}\n\n.purchase-btn-warn {\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 50%, #b45309 100%) !important;\n  box-shadow: 0 4px 16px rgba(245, 158, 11, 0.4) !important;\n}\n\n.purchase-section {\n  text-align: center;\n  margin: 1rem 0;\n}\n\n.purchase-btn {\n  padding: 0.85rem 2rem;\n  font-size: 1.1rem;\n  width: 100%;\n  background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 50%, #2563eb 100%);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 16px rgba(37, 99, 235, 0.4);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.purchase-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 50%, #1d4ed8 100%);\n  box-shadow: 0 6px 24px rgba(37, 99, 235, 0.6);\n}\n\n.purchase-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.payment-methods {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  margin: 1rem 0;\n  padding: 0.6rem;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-primary);\n  border-radius: 10px;\n}\n\n.payment-methods img {\n  height: 40px;\n  width: auto;\n  object-fit: contain;\n  padding: 0.25rem 0.4rem;\n  border-radius: 6px;\n  opacity: 0.85;\n  transition: opacity 0.2s ease, filter 0.2s ease;\n  background: rgba(255, 255, 255, 0.9);\n}\n\n.payment-methods img:hover {\n  opacity: 1;\n}\n\n.payment-info {\n  margin-top: 0.75rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid var(--border-primary);\n}\n\n.payment-info p {\n  margin: 0 0 0.3rem;\n  color: var(--text-secondary);\n  font-size: 0.8rem;\n  line-height: 1.5;\n}\n\n.payment-guide-link,\n.payment-guide-link-inline {\n  color: var(--accent-primary);\n  text-decoration: underline;\n  font-weight: 500;\n}\n\n.payment-guide-link:hover,\n.payment-guide-link-inline:hover {\n  color: var(--accent-hover);\n}\n\n.payment-email-note {\n  margin-top: 0.5rem;\n}\n\n.payment-email-list {\n  margin: 0.25rem 0 0;\n  padding-left: 1.1rem;\n  list-style: disc;\n  color: var(--text-secondary);\n  font-size: 0.8rem;\n  line-height: 1.5;\n}\n\n.payment-email-list li {\n  margin-bottom: 0.15rem;\n}\n\n/* Mobile */\n@media (max-width: 680px) {\n  .payment-dual-cards {\n    display: none;\n  }\n\n  .payment-toggle-wrapper,\n  .payment-mobile-cards {\n    display: block;\n  }\n\n  .payment-card,\n  .payment-single-card {\n    padding: 1.25rem;\n  }\n\n  .card-title {\n    font-size: 1.15rem;\n  }\n\n  .price-amount {\n    font-size: 1.6rem;\n  }\n\n  .purchase-btn {\n    padding: 0.75rem 1.5rem;\n    font-size: 1rem;\n  }\n\n  .payment-methods img {\n    height: 32px;\n  }\n\n  .payment-toggle-btn {\n    padding: 0.65rem 0.6rem;\n    font-size: 0.8rem;\n    gap: 0.4rem;\n    min-height: 54px;\n  }\n\n  .payment-toggle-btn:not(.active) {\n    border-color: var(--border-secondary);\n    border-style: dashed;\n  }\n\n  .toggle-badge {\n    font-size: 0.6rem;\n    padding: 0.1rem 0.4rem;\n  }\n\n  .toggle-btn-label {\n    font-size: 0.82rem;\n  }\n\n  .payment-version-compare {\n    grid-template-columns: 1fr;\n  }\n\n  .payment-toggle-wrapper {\n    margin-bottom: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
